export enum WorkflowStatus {
  REQUESTED = 'REQUESTED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCEEDED = 'SUCCEEDED',
  STOPPED = 'STOPPED',
  FAILED = 'FAILED',
}
